import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { signOut } from "../../context/allotees/apiClass";

// menu
import "../../assets/CSS/index.css";
import MDBox from "../MDBox";
import MDButton from "../MDButton";

import { toggleMenu } from "../utilities/helperFunctions";

const ResponsiveMenu = ({ routes = [] }) => {  // Ensure routes has a default value
  const dispatch = useDispatch();

  const getMobileRoutes = () => {
    return Array.isArray(routes) ? routes.filter((route) => route.responsive) : [];
  };

  return (
    <div className="responsive-menu-off" id="id-mobile-menu">
      <nav>
        <ul>
          {getMobileRoutes().map((link, index) => (
            <li key={link.id || `menu-item-${index}`} className="mobile-menu-item" onClick={toggleMenu}>
              <Link to={link.route}>{link.name}</Link>
            </li>
          ))}
        </ul>
        <MDBox className="mobile-bottom">
          <MDButton onClick={() => dispatch(signOut())}>Log Out</MDButton>
        </MDBox>
      </nav>
    </div>
  );
};

export default ResponsiveMenu;
